let dayjs = require('dayjs').default
if (!dayjs) dayjs = require('dayjs')

let addPatientToProject = function(project, patient, reason, user) {
  // confirm user just a string and not an object
  if (user && typeof user !== 'string') {
    return new Error('user id must be a string')
  }

  if (patient.projects && patient.projects[project]) {
    patient.projects[project].enrolled = true
    var newChangesObject = {
      enrolled: true,
      date: trhcDate.ymd(),
      reason: reason,
      userId: user
    }
    patient.projects[project].changes.push(newChangesObject)
  } else {
    if (!patient.projects) {
      // if their org doc doesn't have projects add it
      patient.projects = {}
    }
    // create project on the patient for the first time
    patient.projects[project] = {
      enrolled: true,
      enrollDate: trhcDate.ymd(),
      changes: [
        {
          enrolled: true,
          date: trhcDate.ymd(),
          userId: user
        }
      ]
    }
  }
}

let trhcDate = { ymd: date => dayjs(date).format('YYYY-MM-DD') }

let isActive = function(project) {
  return dayjs().isBetween(project.projectStart, project.projectEnd, 'days', [])
}

let canEnroll = function(project, patient) {
  if (isActive(project)) {
    return true
  }
}

module.exports = {
  addPatientToProject: addPatientToProject,
  canEnroll: canEnroll
}
